import type { Trigger, PopupInstance, TriggerConfig } from '../types';

export class ScrollDepthTrigger implements Trigger {
	private handler: (() => void) | null = null;
	private fired = false;

	init(popup: PopupInstance, config: TriggerConfig): void {
		const threshold = config.scrollDepthValue;
		const unit = config.scrollDepthUnit || 'percent';

		this.handler = () => {
			if (this.fired) return;

			const scrolled = window.scrollY;
			let reached = false;

			if (unit === 'percent') {
				const docHeight = document.documentElement.scrollHeight - window.innerHeight;
				const pct = docHeight > 0 ? (scrolled / docHeight) * 100 : 0;
				reached = pct >= threshold;
			} else {
				reached = scrolled >= threshold;
			}

			if (reached) {
				this.fired = true;
				popup.show();
			}
		};

		window.addEventListener('scroll', this.handler, { passive: true });
	}

	destroy(): void {
		if (this.handler) {
			window.removeEventListener('scroll', this.handler);
			this.handler = null;
		}
	}
}
